import { Capacitor } from "@capacitor/core";
import { FirebaseAuthentication } from "@capacitor-firebase/authentication";
import { GoogleAuthProvider, OAuthProvider, signInWithCredential, signInWithPopup } from "firebase/auth";
import { auth } from "../firebaseConfig";

/**
 * Inicia sesión con Google o Apple y deja la sesión también en el SDK web de Firebase
 * (necesario para Firestore, Cloud Functions y Storage). Devuelve el usuario de Firebase.
 *
 * En nativo se usa skipNativeAuth: la sesión nativa por sí sola no llega al SDK web.
 */
export const signInWithSocial = async (provider) => {
  if (!Capacitor.isNativePlatform()) {
    const webProvider = provider === "apple" ? new OAuthProvider("apple.com") : new GoogleAuthProvider();
    return (await signInWithPopup(auth, webProvider)).user;
  }

  const options = { skipNativeAuth: true };
  const result =
    provider === "apple"
      ? await FirebaseAuthentication.signInWithApple(options)
      : await FirebaseAuthentication.signInWithGoogle(options);

  const idToken = result.credential?.idToken;
  if (!idToken) throw new Error("No se recibió el token de inicio de sesión.");
  const credential =
    provider === "apple"
      ? new OAuthProvider("apple.com").credential({ idToken, rawNonce: result.credential?.nonce })
      : GoogleAuthProvider.credential(idToken, result.credential?.accessToken);
  return (await signInWithCredential(auth, credential)).user;
};

export const signOutEverywhere = async () => {
  try {
    await auth.signOut();
  } catch (e) {
    console.warn("signOut web:", e);
  }
  try {
    if (Capacitor.isNativePlatform()) await FirebaseAuthentication.signOut();
  } catch (e) {
    console.warn("signOut nativo:", e);
  }
};
